export default "__VITE_ASSET__BD6q5xhm__"